import { render, staticRenderFns } from "./PopularProductList.vue?vue&type=template&id=7eae446a"
import script from "./PopularProductList.vue?vue&type=script&lang=js"
export * from "./PopularProductList.vue?vue&type=script&lang=js"
import style0 from "./PopularProductList.vue?vue&type=style&index=0&id=7eae446a&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports